import React, { useEffect, useState } from "react";

const MONOGRAM_SAGE =
  "https://customer-assets.emergentagent.com/job_boda-invitation-hub/artifacts/itxixsdb_Monogram_526E3B.png";

const SESSION_KEY = "wedding_intro_seen";

const IntroOverlay = () => {
  const [phase, setPhase] = useState(() => {
    if (typeof window !== "undefined" && window.sessionStorage.getItem(SESSION_KEY)) {
      return "done";
    }
    return "in";
  });

  useEffect(() => {
    if (phase === "done") return;
    document.body.style.overflow = "hidden";
    const t1 = setTimeout(() => setPhase("hold"), 700);
    const t2 = setTimeout(() => setPhase("out"), 1900);
    const t3 = setTimeout(() => {
      setPhase("done");
      window.sessionStorage.setItem(SESSION_KEY, "1");
      document.body.style.overflow = "";
    }, 2700);
    return () => {
      clearTimeout(t1);
      clearTimeout(t2);
      clearTimeout(t3);
      document.body.style.overflow = "";
    };
  }, []);

  if (phase === "done") return null;

  const overlayOpacity = phase === "out" ? "opacity-0" : "opacity-100";
  const monoState =
    phase === "in"
      ? "opacity-0 scale-95"
      : phase === "out"
        ? "opacity-0 scale-[1.02]"
        : "opacity-100 scale-100";

  return (
    <div
      data-testid="intro-overlay"
      className={`fixed inset-0 z-[999] bg-[var(--ivory)] flex items-center justify-center transition-opacity duration-[800ms] ease-out ${overlayOpacity}`}
      aria-hidden="true"
    >
      <img
        src={MONOGRAM_SAGE}
        alt=""
        className={`h-28 md:h-36 lg:h-44 w-auto object-contain transition-all duration-[900ms] ease-out ${monoState}`}
      />
    </div>
  );
};

export default IntroOverlay;
